var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'is-mobile': _vm.isMobile,
        'is-index': !_vm.isLoggedIn || _vm.isIndexPageV1,
        'is-style-v2': _vm.useV2,
    },attrs:{"id":"app"}},[_c('veui-loading',{class:{
            'cc-index-loading': true,
            'is-index': !_vm.isLoggedIn || _vm.isIndexPageV1,
        },attrs:{"loading":_vm.loading,"ui":"strong l"}}),_c('router-view'),(_vm.showMessageCenterDialog)?_c('message-center-dialog'):_vm._e(),(_vm.isNeedTrialCoupon)?_c('send-trial-coupon-dialog'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }